import { render, staticRenderFns } from "./TaxRate.vue?vue&type=template&id=d680709e&"
import script from "./TaxRate.vue?vue&type=script&lang=js&"
export * from "./TaxRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports